import {HubApiRequest} from '../hub-api-request';
import {HubMethod} from '../constants/methods';
import {v4 as uuidv4} from 'uuid';
import {
    RegistrationResponse,
    RegistrationWithPasswordReq
} from '../protocol/registration-req';

export class RegistrationWithPassword extends HubApiRequest<RegistrationWithPasswordReq, RegistrationResponse> {
    constructor(url: string, deviceIdentifier: string, data: RegistrationWithPasswordReq) {
        super(url, HubMethod.REGISTRATION_WITH_PASSWORD, deviceIdentifier, data, uuidv4());
    }
}
